<template>
  <div class="repair-container">
    <div class="section-header">
      <div class="header-left">
        <h2 class="title">报修服务管理</h2>
        <span class="sub-title">采购设备与仪器维保申报、故障检修与原厂工程师协同</span>
      </div>
      <el-button type="primary" icon="el-icon-plus" class="btn-create" @click="handleToRepair()">
        新增维修申请
      </el-button>
    </div>

    <!-- 顶部状态胶囊导航 -->
    <div class="tab-capsule-wrapper">
      <div
        v-for="(item, index) in tagList"
        :key="'tag' + index"
        class="tab-capsule"
        :class="{ active: form_head_uuid === item.form_head_uuid }"
        @click="changeIndex(item.form_head_uuid)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>

    <!-- 加载骨架屏 -->
    <div v-if="loading" class="order-skeleton-list">
      <div v-for="i in 3" :key="i" class="sk-order-card">
        <div class="sk-header">
          <div class="sk-bar w-30"></div>
          <div class="sk-bar w-20"></div>
        </div>
        <div class="sk-body">
          <div class="sk-img"></div>
          <div class="sk-details">
            <div class="sk-bar w-60"></div>
            <div class="sk-bar w-40"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 维修报修列表 -->
    <div class="orderBox" v-else-if="orderList && orderList.length > 0">
      <div class="orderTableHeader">
        <span class="col-goods">报修设备/耗材商品</span>
        <span class="col-status">服务状态</span>
      </div>

      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id" class="order-card-item">
          <div class="orderHeader">
            <div class="header-left">
              <span class="orderTime">
                <i class="el-icon-time"></i>
                {{ item.u6g7gjunacqjmudx }}
              </span>
              <span class="orderId">
                维修单编号：{{ item['3pp6dg9j4ex79ook'] }}
              </span>
            </div>
            <div class="header-right">
              <span class="status-badge badge-reviewing">
                处理中
              </span>
            </div>
          </div>

          <div
            class="orderDetail"
            v-for="(order, idx) in item.children"
            :key="idx"
          >
            <img
              v-if="order['0ag6jxdaxesngyli'] && order['0ag6jxdaxesngyli'].length > 0"
              :src="order['0ag6jxdaxesngyli'][0].url"
              alt="商品图片"
              class="goods-thumb"
            />
            <div class="goods-thumb placeholder" v-else>
              <i class="el-icon-tools"></i>
            </div>

            <div class="goodsName">
              <p v-if="order.com1x9fiqphdkau6 && order.com1x9fiqphdkau6.length > 0">
                {{ order.com1x9fiqphdkau6[0].value }}
              </p>
              <p v-else class="text-muted">申报设备/物料</p>
            </div>

            <span class="col-status-text">
              原厂检测 / 工程师排单中
            </span>
          </div>
        </li>
      </ul>

      <!-- 分页组件 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 规范空状态 -->
    <div class="empty-gov-state" v-else>
      <div class="icon-circle">
        <i class="el-icon-setting"></i>
      </div>
      <p class="empty-title">暂无报修申请记录</p>
      <p class="empty-sub">设备出现运行异常或故障时，可点击右上角发起专业售后报修</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { online, children } from "@/api/platform";
import { otherSystemGetLoginToMeUrl } from "@/util/util";

export default {
  name: "Repair",
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      tagList: [
        { name: "全部", form_head_uuid: "067434d8ae9311eea8aa0242321230b4" },
        { name: "审核中", form_head_uuid: "beaea547e2de4b1e8db0d1f443240e33" },
        { name: "审核成功", form_head_uuid: "da07ce01fcb34202ac26c0a9ac6256e3" },
        { name: "审核失败", form_head_uuid: "08656c93268a4802932daaac7078d63e" },
        { name: "已邮寄", form_head_uuid: "9b6e3eab457941c8beb6b46f0a62e206" },
        { name: "取件验收", form_head_uuid: "55a39a13a6074fd49f8fa08ecd312dfb" },
        { name: "维修中", form_head_uuid: "b9ba63c28830497c93a66c229a81e3b0" },
        { name: "总集已发货", form_head_uuid: "d6170e6130c34e89b1f5e25b53e67c75" },
        { name: "确认收货", form_head_uuid: "c93be1c16fc64fdab8177903e4314d0f" },
      ],
      form_head_uuid: "067434d8ae9311eea8aa0242321230b4",
      orderList: [],
      loading: true,
      page: 1,
      total: 0,
      limit: 20,
    };
  },
  mounted () {
    this.getOrderList();
  },
  methods: {
    async getOrderList () {
      this.loading = true;
      try {
        const { form_head_uuid, page, limit } = this;
        const { meta, result } = await online({
          form_head_uuid,
          page,
          limit,
          keyword: "",
          select_option: "",
        });
        if (Array.isArray(result)) {
          this.orderList = await Promise.all(
            result.map(async (el) => ({
              ...el,
              children: await this.children(el.id),
            }))
          );
        } else {
          this.orderList = [];
        }
        this.total = meta && meta.total ? meta.total : 0;
      } catch (e) {
        console.error("加载报修列表失败:", e);
        this.orderList = [];
      } finally {
        this.loading = false;
      }
    },
    async children (record_id) {
      try {
        const { form_head_uuid } = this;
        const { result } = await children({
          page: 1,
          limit: 100,
          field_uuid: "49da24a35fde43bdb527817494ec8524",
          form_head_uuid,
          record_id,
        });
        return Array.isArray(result) ? result : [];
      } catch (e) {
        return [];
      }
    },
    handleCurrentChange (page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex (form_head_uuid) {
      if (this.form_head_uuid === form_head_uuid) return;
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      this.getOrderList();
    },
    handleToRepair () {
      otherSystemGetLoginToMeUrl('b01a7096e59411ee8c5a0242ac150003', 'sg59YQ5afAL0wG45');
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.repair-container {
  width: 100%;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #f1f5f9;

    .header-left {
      display: flex;
      align-items: baseline;
      gap: 12px;

      .title {
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
        margin: 0;
      }

      .sub-title {
        font-size: 13px;
        color: #64748b;
      }
    }

    .btn-create {
      background-color: @brandPrimary;
      border-color: @brandPrimary;
      font-weight: 600;
      padding: 9px 18px;
      border-radius: 6px;

      &:hover {
        background-color: @brandSecondary;
        border-color: @brandSecondary;
      }
    }
  }

  .tab-capsule-wrapper {
    display: flex;
    flex-wrap: wrap;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 8px;
    margin-bottom: 20px;
    gap: 4px;

    .tab-capsule {
      padding: 6px 16px;
      font-size: 13px;
      font-weight: 500;
      color: #64748b;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        color: @brandPrimary;
      }

      &.active {
        background: #ffffff;
        color: @brandPrimary;
        font-weight: 700;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
      }
    }
  }

  /* 骨架屏 */
  .order-skeleton-list {
    display: flex;
    flex-direction: column;
    gap: 14px;

    .sk-order-card {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 16px;
      background: #fff;

      .sk-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #f1f5f9;
      }

      .sk-body {
        display: flex;
        gap: 16px;

        .sk-img {
          width: 72px;
          height: 72px;
          border-radius: 6px;
          background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
          background-size: 200% 100%;
          animation: sk-shimmer 1.5s infinite;
        }

        .sk-details {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
      }

      .sk-bar {
        height: 16px;
        border-radius: 4px;
        background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
        background-size: 200% 100%;
        animation: sk-shimmer 1.5s infinite;

        &.w-20 { width: 20%; }
        &.w-30 { width: 30%; }
        &.w-40 { width: 40%; }
        &.w-60 { width: 60%; }
      }
    }
  }

  @keyframes sk-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* 表头 */
  .orderTableHeader {
    width: 100%;
    height: 42px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px 6px 0 0;
    color: #475569;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;

    span {
      text-align: center;

      &.col-goods {
        flex: 1;
        text-align: left;
        padding-left: 20px;
      }

      &.col-status { width: 180px; }
    }
  }

  /* 列表 */
  .orderList {
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;

    .order-card-item {
      border: 1px solid #e2e8f0;
      border-top: none;
      background: #ffffff;
      transition: all 0.2s ease;
      margin-bottom: 12px;
      border-radius: 0 0 6px 6px;

      &:hover {
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
      }

      .orderHeader {
        background-color: #f8fafc;
        border-bottom: 1px solid #f1f5f9;
        height: 44px;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-left {
          display: flex;
          align-items: center;
          gap: 16px;

          .orderTime {
            font-size: 13px;
            font-weight: 600;
            color: #1e293b;
            display: flex;
            align-items: center;
            gap: 6px;

            i { color: @brandPrimary; }
          }

          .orderId {
            font-size: 12px;
            color: #64748b;
          }
        }

        .header-right {
          .status-badge {
            font-size: 12px;
            padding: 2px 8px;
            border-radius: 4px;
            font-weight: 600;

            &.badge-reviewing {
              background: #eff6ff;
              color: @brandPrimary;
              border: 1px solid #bfdbfe;
            }
          }
        }
      }

      .orderDetail {
        display: flex;
        align-items: center;
        padding: 14px 16px;

        .goods-thumb {
          width: 64px;
          height: 64px;
          border-radius: 6px;
          border: 1px solid #e2e8f0;
          object-fit: cover;
          flex-shrink: 0;

          &.placeholder {
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f1f5f9;
            color: #94a3b8;
            font-size: 24px;
          }
        }

        .goodsName {
          flex: 1;
          padding: 0 16px;

          p {
            margin: 0;
            font-size: 13px;
            line-height: 1.5;
            color: #1e293b;
            font-weight: 500;
          }

          .text-muted {
            color: #94a3b8;
          }
        }

        .col-status-text {
          width: 180px;
          text-align: center;
          font-size: 12px;
          color: #64748b;
          flex-shrink: 0;
        }
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 0;
  }

  /* 空状态 */
  .empty-gov-state {
    padding: 60px 0;
    text-align: center;
    background: #ffffff;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    margin-top: 16px;

    .icon-circle {
      width: 60px;
      height: 60px;
      margin: 0 auto 14px;
      border-radius: 50%;
      background: #eff6ff;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 28px;
        color: @brandPrimary;
      }
    }

    .empty-title {
      font-size: 15px;
      font-weight: 600;
      color: #334155;
      margin: 0 0 6px;
    }

    .empty-sub {
      font-size: 13px;
      color: #94a3b8;
      margin: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/Repair.vue